import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { InputWrapperContainer } from '../../input/inputWrapper.container';
import { trans } from '../../../modules/translation/translate';
import { ServerSeedInputContainer } from '../serverSeedInput';
import { ClientSeedInputContainer } from '../clientSeedInput';
import SeedStoreController from '../../../../../common/components/storeControllers/SeedStoreController';
import { transProvablyFair } from '../../../pages/provablyFair.page/provablyFair.page';

class Session extends PureComponent {
	static propTypes = {
		nonce: PropTypes.any,
		autobetPaused: PropTypes.bool,
		fetch: PropTypes.func,
	};

	componentDidMount() {
		this.props.fetch();
	}

	render() {
		return (
			<>
				<SeedStoreController />
				{this.props.autobetPaused && (
					<p className="text-style-md-medium text-negative margin-bottom">
						{trans({
							label:
								'Current autobet session is paused, changing seeds will affect your next bets',
						})}
					</p>
				)}
				<ClientSeedInputContainer />
				<ServerSeedInputContainer />
				<InputWrapperContainer
					name={'nonce'}
					value={this.props.nonce}
					label={transProvablyFair({ label: 'Nonce' })}
					isDisabled={true}
				/>
			</>
		);
	}
}

export { Session };
